import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { InputControl } from '../../ui-kit/Input/InputControl.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const CommentField = JSX(({ field, input }) => (_jsx(InputControl, { className: "col-span-2", ...getValidation(field('comment'), validatorObj.comment, input?.required), placeholder: "\u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435", isTextarea: true })));
//# sourceMappingURL=CommentField.js.map